import React from 'react'
import { isNil } from 'ramda'
import Store from 'store'
import { User } from 'shared/graphql/auth'
import history from 'shared/utils/history'

export type LogoutFn = (params?: { onCompleted?: () => any }) => any
export let logoutFunc: any

export type AuthContextType = {
  logout: LogoutFn
  isAuthenticated: boolean
  user: User
  setUser: React.Dispatch<React.SetStateAction<User | null>>
  setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>>
}

export const AuthContext = React.createContext<AuthContextType>({
  isAuthenticated: false,
  user: {} as User,
  logout: () => ({}),
  setUser: (value: React.SetStateAction<User | null>) => ({}),
  setIsAuthenticated: (value: React.SetStateAction<boolean>) => ({}),
})

const _user = Store.get('scnt_lightinternal_user')
const _token = Store.get('scnt_lightinternal_token')

export function AuthProvider(props: any) {
  const [isAuthenticated, setIsAuthenticated] = React.useState(
    !isNil(_token) && !isNil(_user)
  )
  const [user, setUser] = React.useState<User>(_user)

  logoutFunc = () => {
    Store.remove('scnt_lightinternal_token')
    Store.remove('scnt_lightinternal_user')
    setIsAuthenticated(false)
    history.push('/')
  }

  const logout = React.useCallback(({ onCompleted } = {}) => {
    Store.remove('scnt_lightinternal_token')
    Store.remove('scnt_lightinternal_user')
    setIsAuthenticated(false)

    history.push('/')

    if (onCompleted) {
      onCompleted()
    }
  }, [])

  const value = React.useMemo(
    () => ({
      isAuthenticated,
      setIsAuthenticated,
      setUser,
      logout,
      user,
    }),
    [isAuthenticated, logout, user, setUser, setIsAuthenticated]
  )

  return <AuthContext.Provider value={value} {...props} />
}

export function useAuth() {
  const context = React.useContext(AuthContext)
  if (context === undefined) {
    throw new Error(`useAuth must be used within a AuthProvider`)
  }
  return context
}

export default useAuth
